<template>
  <div class="menu-manage blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-row type="flex">
      <a-col :span="24" :xl="6">
        <a-row :gutter="16" type="flex" align="middle">
          <a-col flex="1">
            <a-input class="app-block" placeholder="请输入关键字" allow-clear v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
          </a-col>
          <a-col>
            <dy-icon type="icon-add" @click="addNode(null, -1)"></dy-icon>
          </a-col>
        </a-row>
        <a-spin :spinning="tree.loading">
          <a-tree block-node ref="tree" :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys" :expanded-keys.sync="tree.expandedKeys">
            <template slot="title" slot-scope="row">
              <a-row type="flex">
                <a-col flex="1">{{row[tree.params.title]}}</a-col>
                <a-col>
                  <a-dropdown>
                    <a-icon type="ellipsis"></a-icon>
                    <a-menu slot="overlay">
                      <a-menu-item @click="addNode(row, 0)">添加菜单</a-menu-item>
                      <a-menu-item @click="addNode(row, 1)">添加权限按钮</a-menu-item>
                      <a-menu-item @click="delNode(row)">删除</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </a-col>
              </a-row>
            </template>
          </a-tree>
        </a-spin>
      </a-col>
      <a-col :span="24" :xl="18" v-if="typeof form.nodeType === 'number'">
        <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
          <a-form-model-item label="上级节点ID" prop="superiorNodeID">
            <p>{{form.superiorNodeID}}</p>
          </a-form-model-item>
          <a-form-model-item label="节点级别" prop="nodeLevel">
            <p>{{form.nodeLevel}}</p>
          </a-form-model-item>
          <a-form-model-item label="节点类型" prop="nodeType">
            <p>{{form.nodeType === -1 ? '顶部菜单' : (form.nodeType === 0 ? '页面菜单' : '权限按钮')}}</p>
          </a-form-model-item>
          <a-form-model-item label="中文名称" prop="title">
            <a-input v-model="form.title" placeholder="请输入中文名称" allow-clear></a-input>
          </a-form-model-item>
          <!-- 非按钮权限项 -->
          <template v-if="form.nodeType !== 1">
            <a-form-model-item label="英文名称" prop="name">
              <a-input v-model="form.name" placeholder="请输入英文名称" allow-clear></a-input>
            </a-form-model-item>
            <a-form-model-item label="访问地址" prop="url">
              <a-input v-model="form.url" placeholder="请输入访问地址（非一级菜单无需'/'开头）" allow-clear></a-input>
            </a-form-model-item>
            <a-form-model-item label="图标" prop="icon">
              <a-space>
                <dy-icon :type="form.icon" v-if="form.icon"></dy-icon>
                <a-button type="link" @click="showIconLayer">选择</a-button>
              </a-space>
            </a-form-model-item>
            <a-form-model-item label="文件名称" prop="fileName">
              <a-input v-model="form.fileName" placeholder="请输入文件名称" allow-clear></a-input>
            </a-form-model-item>
          </template>
          <!-- 按钮权限项 -->
          <template v-else>
            <a-form-model-item label="权限类型" prop="btnType">
              <a-select v-model="form.btnType" placeholder="请选择权限类型">
                <a-select-option :value="value.value" v-for="(value, index) in btnTypeOptions" :key="index">{{value.title}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="请求路径" prop="requestPath">
              <a-input v-model="form.requestPath" placeholder="请输入请求路径" allow-clear></a-input>
            </a-form-model-item>
            <a-form-model-item label="请求方式" prop="requestType">
              <a-input v-model="form.requestType" placeholder="请输入请求路径" allow-clear></a-input>
            </a-form-model-item>
          </template>
          <a-form-model-item label="排序值" prop="sortNumber">
            <a-input-number v-model="form.sortNumber" placeholder="请输入排序值（值越小越靠前，支持小数）" :min="0" allow-clear></a-input-number>
          </a-form-model-item>
          <!-- 根节点需要设置即可 -->
          <a-form-model-item label="菜单类型" prop="menuType" v-if="!form.nodeLevel">
            <a-radio-group v-model="form.menuType">
              <a-radio :value="0">平台端</a-radio>
              <a-radio :value="1">社区端</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="状态" prop="status">
            <a-radio-group v-model="form.status">
              <a-radio :value="0">隐藏</a-radio>
              <a-radio :value="1">显示</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
            <a-space>
              <a-button type="primary" @click="submit">提交</a-button>
            </a-space>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
    <a-modal title="访问密码" v-model="accessPasswordModal.show" destroy-on-close :closable="false" :mask-closable="false">
      <a-form-model ref="accessPasswordModalForm" :model="accessPasswordModal.form" layout="vertical" :rules="accessPasswordModal.rules">
        <a-form-model-item label="密码" prop="password">
          <a-input v-model="accessPasswordModal.form.password" placeholder="请输入密码" allow-clear type="password"></a-input>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button type="primary" @click="confirmAccessPasswordModal">确定</a-button>
      </template>
    </a-modal>
    <a-modal title="选择图标" v-model="iconModal.show" @ok="confirmIconModal" destroy-on-close>
      <a-row type="flex" class="icon-wrap">
        <a-col :span="8" v-for="(value, index) in iconModal.data" :key="index" :class="{'active': iconModal.selectName === value}" @click="selectIcon(value)">
          <dy-icon :type="value"></dy-icon>
          <p>{{value}}</p>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import iconData from '@/io/icon.js';
  import AuthService from '@/io/auth.js';

  export default {
    name: 'MenuManage',
    data() {
      return {
        tree: {
          keyword: null,
          searchData: [],
          loading: false,
          data: [],
          expandedKeys: [],
          selectedKeys: [],
          params: {
            key: 'id',
            title: 'title',
            children: 'children'
          }
        },
        iconModal: {
          data: iconData,
          show: false,
          selectName: null
        },
        accessPasswordModal: {
          password: 'admin',
          show: true,
          form: {
            password: null
          },
          rules: {}
        },
        form: {
          
        },
        rules: {

        },
        btnTypeOptions: [
          {
            title: '查看',
            value: 'view',
            requestType: 'GET'
          },
          {
            title: '添加',
            value: 'add',
            requestType: 'POST'
          },
          {
            title: '编辑',
            value: 'edit',
            requestType: 'PATCH'
          },
          {
            title: '删除',
            value: 'delete',
            requestType: 'DELETE'
          },
          {
            title: '批量删除',
            value: 'deletes',
            requestType: 'DELETE'
          },
          {
            title: '清空',
            value: 'clear',
            requestType: 'POST'
          },
          {
            title: '启用',
            value: 'enable',
            requestType: 'POST'
          },
          {
            title: '禁用',
            value: 'disable',
            requestType: 'POST'
          },
          {
            title: '搜索',
            value: 'search',
            requestType: 'POST'
          },
          {
            title: '上传文件',
            value: 'upload',
            requestType: 'POST'
          },
          {
            title: '导出',
            value: 'output',
            requestType: ''
          },
          {
            title: '导入',
            value: 'input',
            requestType: 'POST'
          },
          {
            title: '分配权限',
            value: 'editPerm',
            requestType: 'PATCH'
          },
          {
            title: '设为默认',
            value: 'setDefault',
            requestType: 'POST'
          },
          {
            title: '其他操作',
            value: 'other',
            requestType: ''
          },
        ]
      }
    },
    mounted () {
      this.initParams();
      this.initTreeData();
    },
    methods: {
      initTreeData() {
        this.tree.loading = true;
        AuthService.list().then(res => {
          this.tree.expandedKeys = [];
          this.$depthSearchTree(node => {
            if (!node.level) {
              this.tree.expandedKeys.push(node[this.tree.params.key]);
            }
            node.scopedSlots = {
              title: 'title'
            }
          }, res);
          this.tree.data = res;
        }).catch(err => {}).finally(() => {
          this.tree.loading = false;
        });
      },
      confirmAccessPasswordModal() {
        if (this.accessPasswordModal.form.password === this.accessPasswordModal.password) {
          this.accessPasswordModal.show = false;
        } else {
          this.$message.error({
            content: '密码输入错误'
          });
        }
      },
      selectIcon(name) {
        this.iconModal.selectName = name;
      },
      confirmIconModal() {
        this.iconModal.show = false;
        this.form.icon = this.iconModal.selectName;
        this.iconModal.selectName = null;
      },
      showIconLayer() {
        this.iconModal.show = true;
      },
      selectTreeNode(selectedKeys) {
        this.tree.selectedKeys = selectedKeys;
        this.$depthSearchTree(node => {
          if (node[this.tree.params.key] === selectedKeys[0]) {
            this.initParams(
              node.parent_id,
              node.level,
              node.type,
              node.title,
              node.name,
              node.path,
              node.icon,
              node.component,
              node.button_type,
              node.url,
              node.http_method,
              node.sort_order,
              node.is_overall,
              node.status
            );
          }
        }, this.tree.data);
      },
      addNode(data, type) {
        this.tree.selectedKeys = [];
        this.initParams();
        this.form.superiorNodeID = data ? data.id : 0;
        this.form.nodeLevel = data ? data.level + 1 : 0;
        this.form.nodeType = type;
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.tree.selectedKeys.length) {
            AuthService.edit(
              this.tree.selectedKeys[0],
              this.form.superiorNodeID,
              this.form.nodeLevel,
              this.form.nodeType,
              this.form.title,
              this.form.name,
              this.form.url,
              this.form.icon,
              this.form.fileName,
              this.form.btnType,
              this.form.requestPath,
              this.form.requestType,
              this.form.sortNumber,
              this.form.menuType,
              this.form.status
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.initTreeData();
              });
            });
          } else {
            AuthService.add(
              this.form.superiorNodeID,
              this.form.nodeLevel,
              this.form.nodeType,
              this.form.title,
              this.form.name,
              this.form.url,
              this.form.icon,
              this.form.fileName,
              this.form.btnType,
              this.form.requestPath,
              this.form.requestType,
              this.form.sortNumber,
              this.form.menuType,
              this.form.status
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.initParams();
                this.initTreeData();
              });
            });
          }
        });
      },
      delNode(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除？',
          onOk() {
            AuthService.batchDel([data.id]).then(res => {
              self.$afterFormSubmit('删除成功', () => {
                self.initTreeData();
              });
            });
          }
        });
      },
      initParams(
        superiorNodeID,
        nodeLevel,
        nodeType,
        title,
        name,
        url,
        icon,
        fileName,
        btnType,
        requestPath,
        requestType,
        sortNumber,
        menuType,
        status
      ) {
        this.form = {
          superiorNodeID,
          nodeLevel,
          nodeType,
          title,
          name,
          url,
          icon,
          fileName,
          btnType,
          requestPath,
          requestType,
          sortNumber,
          menuType,
          status
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .icon-wrap {
    .ant-col {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100px;
      transition: all @animation-duration-base;
      cursor: pointer;
      .anticon {
        font-size: 30px;
        margin-bottom: @padding-xs;
      }
      &:hover {
        box-shadow: @box-shadow-base;
      }
      &.active {
        background-color: @primary-color;
        color: @white;
      }
    }
  }
</style>